export default __webpack_public_path__ + "static/media/postal_id.118163de.jpg";